import React from 'react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { TextField, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import { StylesProvider, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { ButtonStyles } from './ButtonStyles'
import { hubspotSubmit } from './utils/hubspotSubmit'
import { emailSubmit } from './utils/emailSubmit'

const HubspotFormEndpoint = `https://api.hsforms.com/submissions/v3/integration/submit/7898466/9455dffa-6a43-4871-97f8-b7a2f69d5d86`
const APIEndpoint = `https://api.armansfinejewellery.com/api/contact-enquiry`

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Twentieth Century', 'sans-serif'].join(','),
    fontSize: 12,
  },
})

const ContactForm = () => {
  const { register, handleSubmit, errors } = useForm()

  const onSubmit = async (data: any) => {
    // console.log('Errors', errors)

    hubspotSubmit(data, HubspotFormEndpoint)
    emailSubmit(data, APIEndpoint)

    toast.success(`Thanks ${data.firstname}, Your enquiry has been submitted`)
  }

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <InputGroup>
            <Input
              variant="outlined"
              label="First Name"
              margin="dense"
              fullWidth
              inputRef={register({ required: true })}
              name="firstname"
              type="firstname"
              error={!!errors.firstname}
            />
          </InputGroup>
          <InputGroup>
            <Input
              variant="outlined"
              label="Last Name"
              margin="dense"
              fullWidth
              inputRef={register({ required: true })}
              name="lastname"
              type="lastname"
              error={!!errors.lastname}
            />
          </InputGroup>
          <InputGroup>
            <Input
              variant="outlined"
              label="Email"
              margin="dense"
              fullWidth
              inputRef={register({ required: true })}
              name="email"
              type="email"
              error={!!errors.email}
              helperText={errors.email && 'Looks like you forgot your email'}
            />
          </InputGroup>
          <InputGroup>
            <Input
              variant="outlined"
              label="Phone Number"
              margin="dense"
              fullWidth
              inputRef={register({ required: true })}
              name="phone"
              type="phone"
              error={!!errors.phone}
            />
          </InputGroup>
          <InputGroup>
            <DropdownControl variant="outlined" fullWidth>
              <InputLabel id="how_did_you_hear_about_us_l">How did you hear about us?</InputLabel>
              <Select
                label="How did you hear about us"
                fullWidth
                inputProps={{
                  name: 'how_did_you_hear_about_us_',
                  id: 'how_did_you_hear_about_us_',
                }}
              >
                <MenuItem aria-label="None" value="" />
                <MenuItem value={'Google'}>Google</MenuItem>
                <MenuItem value={'Instagram'}>Instagram</MenuItem>
                <MenuItem value={'Facebook'}>Facebook</MenuItem>
                <MenuItem value={'Word Of Mouth'}>Word Of Mouth</MenuItem>
                <MenuItem value={'Print Media'}>Print Media</MenuItem>
                <MenuItem value={'Website'}>Website</MenuItem>
                <MenuItem value={'Other'}>Other</MenuItem>
              </Select>
            </DropdownControl>
          </InputGroup>

          <InputGroup key="Message">
            <Input variant="outlined" label="Message" margin="dense" fullWidth multiline rows={4} inputRef={register} name="message" />
          </InputGroup>
          <SubmitButton type="submit"></SubmitButton>
        </Form>
      </ThemeProvider>
    </StylesProvider>
  )
}

export { ContactForm }

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 100%;
  background: white;
`
// Varies from the inputGroup in the enquiry form only in that it's not animated
const InputGroup = styled.div`
  border-radius: 5px;
  color: white;
  width: 44%;

  @media (max-width: 768px) {
    width: 94%;
  }

  &:nth-last-child(2),
  &:nth-last-child(3) {
    width: 94%;
  }
`

const Input = styled(TextField)`
  & .MuiFormLabel-root {
    font-family: Slate, sans-serif;
    font-weight: 100;
  }
`

const DropdownControl = styled(FormControl)`
  margin-top: 0.4rem;

  & .MuiInputLabel-outlined {
    /* transform: translate(14px, 14px); */
    font-family: Slate, sans-serif;
    font-weight: 100;
  }
`
const SubmitButton = styled.input`
  ${ButtonStyles}
  margin-top: 2rem;
  width: 94%;
`
